import { Button, HFlow } from 'bold-ui'
import React from 'react'

interface PrescricaoMedicamentoFormActionButtonsProps {
  isRenovacao: boolean
  onReset: () => void
  onSubmit: () => void
}

export const PrescricaoMedicamentoFormActionButtons = (
  props: Readonly<PrescricaoMedicamentoFormActionButtonsProps>
) => {
  const { isRenovacao, onReset, onSubmit } = props
  return (
    <HFlow justifyContent='flex-end'>
      <Button onClick={onReset} size='small' data-cy='LimparCamposButton' disabled={isRenovacao}>
        Limpar campos
      </Button>
      <Button kind='primary' size='small' onClick={onSubmit} data-cy='SalvarButton'>
        Salvar prescrição
      </Button>
    </HFlow>
  )
}
